import { type ReactNode, useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { trackVisitOnce } from "@/lib/track";
import { useStatsTracking } from "@/hooks/useStatsTracking";

export function Layout({ children }: { children: ReactNode }) {
  useStatsTracking();

  useEffect(() => {
    trackVisitOnce();
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-background to-secondary/30">
      <Header />
      <main className="container mx-auto w-full max-w-5xl flex-1 px-4 py-6 sm:py-10">
        {children}
      </main>
      <Footer />
    </div>
  );
}
